import { useState, useEffect } from "react"
import { Button, Link, Text } from "@planningcenter/tapestry-react"
import { string } from "prop-types"
import { Client } from "@planningcenter/api-client"

IntegrationSetup.propTypes = {
  checkInsEventWizardUrl: string.isRequired,
  signupId: string.isRequired
}
export function IntegrationSetup({ checkInsEventWizardUrl, signupId }) {
  const { loading, events } = useCheckInsEventLinks(signupId)

  return (
    <>
      <div className="mb-2">
        <Text>
          Keep your event data in sync by connecting your Signup with Check-Ins. This integration
          lets you carry over assignments, see who&apos;s registered, print labels, and adjust event
          settings with real-time updates across both products.{" "}
          <Link
            href="https://pcocheck-ins.zendesk.com/hc/en-us/articles/25103685567515-Take-Attendance-for-Registrations-Signups"
            external
          >
            Learn more
          </Link>
        </Text>

        <Button
          disabled={loading}
          theme="create"
          title="Create Check-Ins event"
          iconLeft={{ name: "general.newWindow" }}
          className="mt-2"
          data-pendo="create-check-ins-event"
          onClick={() => window.open(checkInsEventWizardUrl, "_blank", "noopener,noreferrer")}
        />
      </div>
      {events.length > 0 && !loading && (
        <div>
          <Text weight={600}>Connected events</Text>
          <ul className="unstyled">
            {events.map(event => (
              <li key={event.href}>
                <Link href={event.href} external>
                  {event.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

const checkInsClient = new Client({
  app: "check-ins",
  version: "2025-05-28"
})

const getEvents = signupId =>
  checkInsClient.get({
    url: `/events/`,
    data: {
      where: {
        registration_event_id: signupId
      },
      fields: { Event: "name" },
      per_page: 100
    }
  })

function useCheckInsEventLinks(signupId) {
  const [loading, setLoading] = useState(true)
  const [events, setEvents] = useState([])

  useEffect(() => {
    setLoading(true)
    getEvents(signupId)
      .then(response => {
        const eventLinks = response.data.map(event => ({
          href: event.links.html,
          name: event.name
        }))
        setEvents(eventLinks)
      })
      .finally(() => setLoading(false))
  }, [signupId])

  return { loading, events }
}
